import {
  FavoriteLink,
  FavoriteLinkIconKey,
} from '@internal/plugin-management-common';

const ALLOWED_ICONS: readonly FavoriteLinkIconKey[] = [
  'code',
  'assignment',
  'dashboard',
  'extension',
  'libraryBooks',
  'link',
  'helpOutline',
] as const;

export function selectHomeFavoriteLinks(
  items: FavoriteLink[],
  limit: number,
): FavoriteLink[] {
  return [...items]
    .filter(item => item.group === 'favorite-link')
    .sort((a, b) => a.order - b.order)
    .slice(0, limit);
}

/** Maps API icon keys to a safe key; unknown values fall back to `link`. */
export function normalizeFavoriteIconKey(
  raw: string | undefined,
): FavoriteLinkIconKey {
  if (raw && (ALLOWED_ICONS as readonly string[]).includes(raw)) {
    return raw as FavoriteLinkIconKey;
  }
  return 'link';
}
